<template>
  <div class="modal-body-variacoes-detalhes">
    <div
      class="variacoes-detalhes-container base animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="variacoes-detalhes-container01">
        <div class="variacoes-detalhes-title">
          <h3>Variações</h3>
        </div>
        <div class="variacoes-detalhes-close">
          <svg
            viewBox="0 0 1024 1024"
            class="variacoes-detalhes-icon"
            @click="closeModal"
          >
            <path
              d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="variacoes-detalhes-container02">
        <v-data-table
          class="variacoes-detalhes-container03"
          :headers="headersVariacoes"
          no-data-text="Não há variações para este produto"
          loading-text="Buscando informações"
          :loading="$produtos_gerenciar.variacoes_loading"
          :items="tableValues"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10],
            itemsPerPageText: 'Variações por página:',
          }"
        >
          <template v-slot:item.preco="{ item }">
            {{ item.preco | moeda }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import products from "@/mixins/products.js";
import _ from "lodash";

export default {
  name: "ProdutosVariacoes",
  mixins: [products],
  methods: {
    closeModal() {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos = [];
      document.getElementsByClassName(
        "modal-body-variacoes-detalhes"
      )[0].style.display = "none";
    },
  },
  computed: {
    tableValues() {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.forEach(
        item => {
          item.descricao = this.$config.convertTagString(item.descricao);
        }
      );

      return _.orderBy(
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos,
        "descricao"
      );
    },
  },
  mounted() {
    if (!this.$axios.getLocal("tipos-variacoes")) {
      this.$produtos_gerenciar.getTiposVariacoes();
    }
    this.$produtos_gerenciar.tipo_variacoes =
      this.$axios.getLocal("tipos-variacoes").data;
  },
};
</script>

<style scoped>
.modal-body-variacoes-detalhes {
  display: none;
  position: fixed;
  z-index: 888;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
}

.variacoes-detalhes-container {
  width: auto;
  max-width: 1200px;
  max-height: 900px;
  display: flex;
  z-index: 100;
  position: relative;
  overflow: auto;
  box-shadow: 1px 1px 30px 3px #000000;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.variacoes-detalhes-container01 {
  flex: 0 0 auto;
  width: 100%;
  height: 10%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
}

.variacoes-detalhes-title {
  width: 97%;
  display: flex;
  justify-content: center;
}

.variacoes-detalhes-close {
  position: absolute;
  width: 5%;
  display: flex;
  justify-content: flex-end;
}

.variacoes-detalhes-icon {
  width: 24px;
  height: 24px;
  margin-top: 3px;
  margin-right: 6px;

  transition: all 0.2s ease;
}

.variacoes-detalhes-icon:hover {
  fill: #fff;
  cursor: pointer;
}

.variacoes-detalhes-container02 {
  flex: 0 0 auto;
  width: auto;
  height: 10%;
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  flex-direction: row;
  justify-content: center;
}

.variacoes-detalhes-container02:hover {
  cursor: pointer;
}

.variacoes-detalhes-container02 {
  flex: 0 0 auto;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  padding: 1.25rem;
  flex-direction: column;
  justify-content: center;
}

.variacoes-detalhes-container03 {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}
</style>
